import React from 'react';
import { AuthProvider } from '../../../contexts/AuthContext';
import Login from './Login';
import Navbar from "../../Navbar";

const LoginPage = (props) => {
    return (
        <AuthProvider>
            <Navbar/>
            <Login />
        </AuthProvider>
    );
};

export default LoginPage;
